import {
  MOBILE_MEDIA_QUERY,
  guessIsMobileFromHeaders,
  useIsMobile,
} from '~/composables/useIsMobile';

/**
 * 維護 `useIsMobile()` 的值（設計說明見該 composable）。
 *
 * 伺服器端：用 header 猜初值，讓 SSR 就能吐出正確的殼，手機不必先看到桌面版再閃成手機版。
 * 瀏覽器端：mounted 後以真實視窗寬度校正，之後跟著 media query 變動（旋轉、縮放視窗）。
 */
export default defineNuxtPlugin((nuxtApp) => {
  const isMobile = useIsMobile();

  if (import.meta.server) {
    isMobile.value = guessIsMobileFromHeaders(
      useRequestHeaders(['sec-ch-ua-mobile', 'user-agent'])
    );
    return;
  }

  const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
  const sync = () => {
    isMobile.value = mediaQuery.matches;
  };

  // hydration 完成前不能改值：SSR 猜的初值已經序列化進 payload，這時改掉會讓兩邊的 vnode 樹對不上
  nuxtApp.hook('app:mounted', sync);
  mediaQuery.addEventListener('change', sync);
});
